// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbsWrap":"breadcrumbs_breadcrumbsWrap__I4iXs","breadcrumb":"breadcrumbs_breadcrumb__vNpJd","breadcrumbText":"breadcrumbs_breadcrumbText__zowmJ"};